import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_REGLEMENT_SCHEMA_LITERAL = {
    title: 'Schéma Reglement',
    description: 'Décrit une reglement',
    version: 1,
    keyCompression: false,
    primaryKey: 'CBINDICE',
    type: 'object',
    properties: {
        CBINDICE: { type: 'string', maxLength : 2 },
        R_INTITULE: { type: 'string' },
        SCD_TYPE: { type: 'number' },
        JO_NUMCLI: { type: ['string', 'null'] , default : '' },
        JO_NUMFOUR: { type: ['string', 'null'] , default : '' },
        ZCD_INDEX: { type: 'number' },
        ZCD_IS_ESPECE: { type: 'boolean' },
        ZCD_IS_EXPRESS: { type: 'boolean' },
        ZCD_P_DEVISE_ACCEPTED: { type: 'boolean' },
        ZCD_USE_LIGHT_COLOR: { type: 'boolean' },
        ZCD_BACKGROUND_COLOR: { type: ['string', 'null'] , default : '' },
        ZCD_ICON: { type: ['string', 'null'], default : '' },
        ZCD_ICON_COLOR: { type: ['string', 'null'], default : '' }
    },
    required: [ 'CBINDICE', 'R_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_REGLEMENT_SCHEMA_LITERAL);
export type RxPReglementDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_REGLEMENT_SCHEMA: RxJsonSchema<RxPReglementDocumentType> = P_REGLEMENT_SCHEMA_LITERAL;
